module.exports = __webpack_public_path__ + "img/clint4.24e592ab.png";